import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Main from './Components/Main';
import Schedule from './Components/Schedule';
import Result from './Components/Result';
import Navigation from './Components/Navigation';
import Support from './Components/Support';
import TermsAndConditions from './Components/TermsAndConditions'; // Import the new component

function App() {
  return (
    <div>
      <Navigation/>
      <Container fluid="md">
        <Router>
          <Routes>
            <Route exact path='/' element={<Main />} />
            <Route path='/schedule' element={<Schedule />} />
            <Route path='/result' element={<Result />} />
            <Route path='/terms-and-conditions' element={<TermsAndConditions />} /> {/* New route */}
          </Routes>
        </Router>
        <Support/>
      </Container>
    </div>
  );
}

export default App;
